import {
  MegaphoneIcon,
  WrenchScrewdriverIcon,
  BookOpenIcon,
  PencilSquareIcon,
  CameraIcon,
  DocumentTextIcon,
  PaperAirplaneIcon,
  VideoCameraIcon,
  LightBulbIcon,
  ChartBarIcon,
  GiftIcon,
  ChatBubbleLeftRightIcon
} from '@heroicons/react/24/outline';

export const communityPortraits = [
  '/community/jws-img.png',
  '/community/jws-img-1.png',
  '/community/jws-img-2.png',
  '/community/jws-img-3.png',
  '/community/jws-img-4.png',
  '/community/jws-img-5.png',
  '/community/jws-img-6.png',
  '/community/jws-img-7.png',
  '/community/jws-img-8.png',
  '/community/jws-img-9.png',
  '/community/jws-img-11.png',
  '/community/jws-img-12.png',
  '/community/jws-img-13.png',
  '/community/jws-img-14.png',
  '/community/jws-img-15.png',
  '/community/jws-img-16.png',
  '/community/jws-img-17.png',
  '/community/jws-img-18.png',
  '/community/jws-img-19.png',
  '/community/jws-img-20.png',
  '/community/jws-img-21.png',
  '/community/jws-img-22.png',
  '/community/jws-img-23.png',
  '/community/jws-img-24.png',
  '/community/jws-img-25.png',
  '/community/jws-img-26.png',
  '/community/jws-img-27.png',
  '/community/jws-img-28.png',
  '/community/jws-img-29.png',
  '/community/jws-img-30.png',
  '/community/jws-img-31.png',
  '/community/jws-img-32.png',
  '/community/jws-img-33.png',
  '/community/jws-img-34.png',
  '/community/jws-img-35.png',
  '/community/jws-img-36.png',
  '/community/jws-img-37.png',
  '/community/jws-img-38.png',
  '/community/jws-img-40.png',
  '/community/jws-img-41.png',
  '/community/jws-img-42.png',
  '/community/jws-img-43.png',
  '/community/jws-img-44.png',
  '/community/jws-img-45.png',
  '/community/jws-img-46.png',
  '/community/jws-img-47.png',
  '/community/jws-img-48.png',
];

export const communityGroups = [
  {
    slug: 'promote-your-brand',
    title: 'Promote your brand',
    shortDescription: 'Get featured, share content, and give your work more visibility.',
    heroDescription: 'Use Boutee as a place to amplify your work. Share content, send editorial ideas, and put your brand in front of more people.',
    icon: MegaphoneIcon,
    accent: {
      background: 'var(--Purple-50)',
      foreground: 'var(--Purple-700)',
      border: 'var(--Purple-200)'
    },
    items: [
      {
        title: 'Share social media content',
        description: 'Send photos, videos, and workshop moments for the Boutee social channels.',
        path: '/social-media',
        cta: 'Open page',
        type: 'internal',
        icon: CameraIcon,
        image: '/community/share-social-media-content.png'
      },
      {
        title: 'Submit a blog',
        description: 'Share a written piece you would like featured on the Boutee blog.',
        path: 'https://forms.gle/Dym7Qifu2GrbjkxD6',
        cta: 'Open form',
        type: 'external',
        icon: DocumentTextIcon,
        image: '/community/submit-a-blog.png'
      },
      {
        title: 'Send us workshop or product videos',
        description: 'Share video content for reels, features, or future academy material.',
        path: '/contact-support',
        cta: 'Contact us',
        type: 'internal',
        icon: VideoCameraIcon,
        image: '/community/workshop-product-videos.png'
      }
    ]
  },
  {
    slug: 'shape-boutee',
    title: 'Shape Boutee',
    shortDescription: 'Suggest features, vote on ideas, and respond to surveys when they are live.',
    heroDescription: 'This is where jewellers influence what gets built next. Use it to flag friction, suggest improvements, and respond when we ask for feedback.',
    icon: WrenchScrewdriverIcon,
    accent: {
      background: 'var(--Blue-50)',
      foreground: 'var(--Blue-700)',
      border: 'var(--Blue-200)'
    },
    items: [
      {
        title: 'Suggest a feature',
        description: 'Send an idea for something that would improve the portal or overall jeweller experience on Boutee.',
        path: '/feedback',
        cta: 'Share idea',
        type: 'internal',
        icon: LightBulbIcon,
        image: '/community/suggest-a-feature.png'
      },
      {
        title: 'Vote on requested features - COMING SOON',
        description: 'See what other jewellers are asking for and add your support.',
        path: '/feedback',
        cta: 'Make suggestions in the meantime',
        type: 'internal',
        icon: ChatBubbleLeftRightIcon,
        image: '/community/vote-on-requested-features.png'
      },
      {
        title: 'Current polls and surveys',
        description: 'No live surveys right now. New surveys will appear here when we are gathering feedback.',
        cta: 'No surveys live',
        type: 'empty',
        icon: ChartBarIcon,
        image: '/community/current-polls-and-surveys.png'
      }
    ]
  },
  {
    slug: 'grow-the-network',
    title: 'Grow the network',
    shortDescription: 'Refer jewellers, share Boutee, and help expand the community.',
    heroDescription: 'If you know jewellers who would fit Boutee well, this section gives you a clean path to introduce them and share the platform.',
    icon: PaperAirplaneIcon,
    accent: {
      background: 'var(--Green-50)',
      foreground: 'var(--Green-700)',
      border: 'var(--Green-200)'
    },
    items: [
      {
        title: 'Refer a jeweller',
        description: 'Send a jeweller to Boutee and earn a £50 reward when they join.',
        path: '/refer-jeweller',
        cta: 'Open referral page',
        type: 'internal',
        icon: GiftIcon,
        image: '/community/refer-a-jeweller.png'
      },
      {
        title: 'Share Boutee',
        description: 'Use the overview and share message tools to explain Boutee clearly. This will be useful if another jeweller has asked you about Boutee.',
        path: '/share-boutee',
        cta: 'Open share tools',
        type: 'internal',
        icon: PaperAirplaneIcon,
        image: '/community/share-boutee.png'
      }
    ]
  },
  {
    slug: 'share-your-story',
    title: 'Share your story',
    shortDescription: 'Contribute interviews, educational content, and behind-the-scenes perspective.',
    heroDescription: 'This is the more editorial side of the community. Tell your story, contribute educational content, and help shape the voice of the network.',
    icon: BookOpenIcon,
    accent: {
      background: 'var(--Grey-100)',
      foreground: 'var(--Orange-700)',
      border: 'var(--Stroke-Light)'
    },
    items: [
      {
        title: 'Complete a written interview',
        description: 'Take part in a founder or jeweller spotlight feature for the Boutee community.',
        path: 'https://forms.gle/RwB65msQfFjoNgZP9',
        cta: 'Answer some questions',
        type: 'internal',
        icon: PencilSquareIcon,
        image: '/community/complete-a-written-interview.png'
      },
      {
        title: 'Contribute an academy video',
        description: 'Share useful insight, process, or expertise on our Boutee Academy.',
        path: '/contact-support',
        cta: 'Register interest',
        type: 'internal',
        icon: VideoCameraIcon,
        image: '/community/contribute-an-academy-video.png'
      },
      {
        title: 'Send a behind-the-brand story',
        description: 'Share your journey, workshop perspective, or a story worth featuring. We\'ll highlight it on our socials.',
        path: '/contact-support',
        cta: 'Contact us',
        type: 'internal',
        icon: DocumentTextIcon,
        image: '/community/behind-the-brand-story.png'
      }
    ]
  }
];

export const getCommunityGroup = (slug) =>
  communityGroups.find((group) => group.slug === slug);
